import { render, staticRenderFns } from "./ConsentBanner.vue?vue&type=template&id=18b7b357&scoped=true&"
import script from "./ConsentBanner.vue?vue&type=script&lang=js&"
export * from "./ConsentBanner.vue?vue&type=script&lang=js&"
import style0 from "./ConsentBanner.vue?vue&type=style&index=0&id=18b7b357&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b7b357",
  null
  
)

export default component.exports